// @ts-nocheck
import { useState, useEffect, useReducer } from 'react';
import { Button } from 'primereact/button';
import { Divider } from 'primereact/divider';
import { Card } from 'primereact/card';
import { Dropdown } from 'primereact/dropdown';
import reactCSS from 'reactcss';
import { SketchPicker } from 'react-color';
import "../../assets/functionalComponents/_dialog.scss"
import "../../assets/functionalComponents/_dataItem.scss"

const BIMAttrsOption = (props) => {
    const [color, setColor] = useState({
        r: props.Attrs.r,
        g: props.Attrs.g,
        b: props.Attrs.b,
        a: props.Attrs.a / 255,
    });
    const [displayColorPicker, setDisplayColorPicker] = useState(false);
    const [, forceUpdate] = useReducer(num => num + 1, 0);

    const styles = reactCSS({
        'default': {
            color: {
                width: '100%',
                height: '14px',
                borderRadius: '2px',
                background: `rgba(${color.r}, ${color.g}, ${color.b}, ${color.a})`,
            },
            swatch: {
                padding: '5px',
                width: '100%',
                background: '#fff',
                borderRadius: '10px',
                boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
                display: 'inline-block',
                cursor: 'pointer',
            },
            popover: {
                position: 'relative',
                zIndex: '2000'
            },
            cover: {
                position: 'fixed',
                top: '0px',
                right: '0px',
                bottom: '0px',
                left: '0px',
            },
        },
    });

    useEffect(() => {
        let layerHandel = props.layerHandel;
        let openAttrsList = props.openAttrsList;
        let isOtherEnable = props.isOtherEnable;
        layerHandel.setEntityColorFunction(["Family"], function (id, attrs, color) {
            let isTrue = false;
            for (let i = 0; i < openAttrsList.length; i++) {
                if (attrs[0] === openAttrsList[i].Attrs) {
                    color[0] = openAttrsList[i].r;
                    color[1] = openAttrsList[i].g;
                    color[2] = openAttrsList[i].b;
                    color[3] = openAttrsList[i].a;
                    isTrue = true;
                    return openAttrsList[i].enable;
                }
            }
            if (!isTrue) {
                color[3] = 0;
                return isOtherEnable;
            }
        })
    }, [props])

    const handleChange = (color) => {
        let layerHandel = props.layerHandel;
        let openAttrsList = props.openAttrsList;
        let isOtherEnable = props.isOtherEnable;
        let Attrs = props.Attrs;
        let onChangeAttrs = props.onChangeAttrs;
        setColor(color.rgb);
        for (let i = 0; i < openAttrsList.length; i++) {
            if (openAttrsList[i].Name === Attrs.Name) {
                openAttrsList[i].r = Attrs.r = color.rgb.r;
                openAttrsList[i].g = Attrs.g = color.rgb.g;
                openAttrsList[i].b = Attrs.b = color.rgb.b;
                openAttrsList[i].a = Attrs.a = color.rgb.a * 255;
                break;
            }
        };
        layerHandel.setEntityColorFunction(["Family"], function (id, attrs, color) {
            let isTrue = false;
            for (let i = 0; i < openAttrsList.length; i++) {
                if (attrs[0] === openAttrsList[i].Attrs) {
                    color[0] = openAttrsList[i].r;
                    color[1] = openAttrsList[i].g;
                    color[2] = openAttrsList[i].b;
                    color[3] = openAttrsList[i].a;
                    isTrue = true;
                    return openAttrsList[i].enable;
                }
            }
            if (!isTrue) {
                color[3] = 0;
                return isOtherEnable;
            }
        });
        onChangeAttrs(openAttrsList);
        forceUpdate();
    }

    const isAttrsEnable = () => {
        let layerHandel = props.layerHandel;
        let openAttrsList = props.openAttrsList;
        let isOtherEnable = props.isOtherEnable;
        let Attrs = props.Attrs;
        let onChangeAttrs = props.onChangeAttrs;
        for (let i = 0; i < openAttrsList.length; i++) {
            if (openAttrsList[i].Name === Attrs.Name) {
                openAttrsList[i].enable = Attrs.enable = !Attrs.enable;
                break;
            }
        };
        layerHandel.setEntityColorFunction(["Family"], function (id, attrs, color) {
            let isTrue = false;
            for (let i = 0; i < openAttrsList.length; i++) {
                if (attrs[0] === openAttrsList[i].Attrs) {
                    color[0] = openAttrsList[i].r;
                    color[1] = openAttrsList[i].g;
                    color[2] = openAttrsList[i].b;
                    color[3] = openAttrsList[i].a;
                    isTrue = true;
                    return openAttrsList[i].enable;
                }
            }
            if (!isTrue) {
                color[3] = 0;
                return isOtherEnable;
            }
        });
        onChangeAttrs(openAttrsList);
        forceUpdate();
    }

    const deleteAttrsOption = () => {
        let layerHandel = props.layerHandel;
        let openAttrsList = props.openAttrsList;
        let isOtherEnable = props.isOtherEnable;
        let Attrs = props.Attrs;
        let deleteBIMAttrs = props.deleteBIMAttrs;
        for (let i = 0; i < openAttrsList.length; i++) {
            if (openAttrsList[i].Name === Attrs.Name) {
                openAttrsList.splice(i, 1);
                break;
            }
        };
        layerHandel.setEntityColorFunction(["Family"], function (id, attrs, color) {
            let isTrue = false;
            for (let i = 0; i < openAttrsList.length; i++) {
                if (attrs[0] === openAttrsList[i].Attrs) {
                    color[0] = openAttrsList[i].r;
                    color[1] = openAttrsList[i].g;
                    color[2] = openAttrsList[i].b;
                    color[3] = openAttrsList[i].a;
                    isTrue = true;
                    return openAttrsList[i].enable;
                }
            }
            if (!isTrue) {
                color[3] = 0;
                return isOtherEnable;
            }
        });
        deleteBIMAttrs(openAttrsList, Attrs);
    }

    return (
        <div className="field grid">
            <label htmlFor="coverDropdown" class="col-12 mb-4 md:col-4 md:mb-0">{props.Attrs.Name}</label>
            <div className="col-6 md:col-4" style={{ alignSelf: 'center' }}>
                <div style={{ textAlign: 'center' }}>
                    <div style={styles.swatch} onClick={() => setDisplayColorPicker(!displayColorPicker)}>
                        <div style={styles.color} />
                    </div>
                    {
                        displayColorPicker ?
                            <div style={styles.popover}>
                                <div style={styles.cover} onClick={() => setDisplayColorPicker(false)} />
                                <SketchPicker color={color} onChange={handleChange} />
                            </div> : null
                    }
                </div>
            </div>
            <div className="col-3 md:col-2" style={{ alignSelf: "center", textAlign: "center" }}>
                {
                    props.Attrs.enable ?
                        <Button icon="pi pi-eye-slash" className="p-button-rounded p-button-warning" onClick={(e) => isAttrsEnable()} /> :
                        <Button icon="pi pi-eye" className="p-button-rounded p-button-info" onClick={(e) => isAttrsEnable()} />
                }
            </div>
            <div className="col-3 md:col-2" style={{ alignSelf: "center", textAlign: "center" }}>
                <Button icon="pi pi-minus" className="p-button-rounded p-button-danger" onClick={(e) => deleteAttrsOption()} />
            </div>
        </div>
    );

}

export const ModelOption = (props) => {
    const [layer, setLayer] = useState({});
    const [optionOpen, setOptionOpen] = useState(false);
    const [overlay, setOverlay] = useState(null);
    const [attrsList, setAttrsList] = useState([]);
    const [openAttrsList, setOpenAttrsList] = useState([]);
    const [BIMAttrsChange, setBIMAttrsChange] = useState(null);
    const [isOtherEnable, setIsOtherEnable] = useState(true);
    const [, forceUpdate] = useReducer(num => num + 1, 0);

    useEffect(() => {
        setLayer(props.layer)
        setAttrsList(props.layer.BIMATTRS)
        if (props.layer.layerSetting) {
            setOptionOpen(props.layer.layerSetting.optionOpen);
            setOverlay(props.layer.layerSetting.overlay);
            setOpenAttrsList(props.layer.layerSetting.openAttrsList)
            setBIMAttrsChange(props.layer.layerSetting.BIMAttrsChange)
            setIsOtherEnable(props.layer.layerSetting.isOtherEnable)
        }
    }, [props.layer])

    useEffect(() => {
        let item = props.layer;
        item.layerSetting = {
            optionOpen: optionOpen,
            overlay: overlay,
            openAttrsList: openAttrsList,
            BIMAttrsChange: BIMAttrsChange,
            isOtherEnable: isOtherEnable
        };
        props.layerUpdate(item, props.index);
    }, [optionOpen, overlay, openAttrsList, BIMAttrsChange, isOtherEnable])

    const setOverlayCover = (e) => {
        if (e.value) {
            layer.layerObject.setOverlayName(e.value.TITLE);
            window.main.OView.updateScreen();
            setOverlay(e.value);
        }
        else {
            layer.layerObject.setOverlayName(null);
            window.main.OView.updateScreen();
            setOverlay(null);
        }
    }

    const addBIMAttrs = () => {
        let attrsListItem = attrsList;
        let openAttrsListItem = openAttrsList;
        let BIMAttrsChangeItem = BIMAttrsChange;
        for (let i = 0; i < attrsListItem.length; i++) {
            if (attrsListItem[i] === BIMAttrsChangeItem) {
                openAttrsListItem.push({
                    Name: attrsListItem[i].NAME,
                    Attrs: attrsListItem[i].ATTRS,
                    r: 255,
                    g: 0,
                    b: 0,
                    a: 255,
                    enable: true
                });
                attrsListItem.splice(i, 1);
                if (attrsListItem[i])
                    BIMAttrsChangeItem = attrsListItem[i];
                else
                    BIMAttrsChangeItem = attrsListItem[0];
                setAttrsList(attrsListItem);
                setOpenAttrsList(openAttrsListItem);
                setBIMAttrsChange(BIMAttrsChangeItem);
                return null;
            }
        }
    }

    const deleteBIMAttrs = (openAttrsList, Attrs) => {
        let attrsListItem = attrsList;
        attrsListItem.push(
            {
                NAME: Attrs.Name,
                ATTRS: Attrs.Attrs
            }
        );
        setAttrsList(attrsListItem);
        setOpenAttrsList(openAttrsList);
        forceUpdate();
    }

    const enableOtherAttr = () => {
        let isOtherEnableItem = !isOtherEnable;
        layer.layerObject.setEntityColorFunction(["Family"], function (id, attrs, color) {
            let isTrue = false;
            for (let i = 0; i < openAttrsList.length; i++) {
                if (attrs[0] === openAttrsList[i].Attrs) {
                    color[0] = openAttrsList[i].r;
                    color[1] = openAttrsList[i].g;
                    color[2] = openAttrsList[i].b;
                    color[3] = openAttrsList[i].a;
                    isTrue = true;
                    return openAttrsList[i].enable;
                }
            }
            if (!isTrue) {
                color[3] = 0;
                return isOtherEnableItem;
            }
        });
        setIsOtherEnable(isOtherEnableItem);
    }

    const clearEntityColor = () => {
        let attrsListItem = attrsList;
        openAttrsList.forEach((Item) => {
            attrsListItem.push({
                NAME: Item.Name,
                ATTRS: Item.Attrs
            });
        })
        setAttrsList(attrsListItem);
        setOpenAttrsList([]);
        setBIMAttrsChange(null);
        setIsOtherEnable(true);
        layer.layerObject.removeEntityColorFunction();
    }

    const BIMModelOption = () => {
        if (!layer.ISBIM)
            return null;
        return (
            <div>
                <div className="field grid">
                    <label htmlFor="coverDropdown" class="col-12 mb-4 md:col-4 md:mb-0">屬性上色：</label>
                    <div className="col-9 md:col-6">
                        <Dropdown className="inputfield w-full" inputId="coverDropdown" value={BIMAttrsChange} options={attrsList} onChange={(e) => setBIMAttrsChange(e.value)} optionLabel="NAME" showClear placeholder="Select a Attrs." />
                    </div>
                    <div className="col-3 md:col-2" style={{ alignSelf: "center", textAlign: "center" }}>
                        <Button icon="pi pi-plus" className="p-button-rounded p-button-info" onClick={(e) => addBIMAttrs()} />
                    </div>
                </div>
                {
                    openAttrsList.map(
                        (Attrs) =>
                            <BIMAttrsOption
                                Attrs={Attrs}
                                layerHandel={layer.layerObject}
                                openAttrsList={openAttrsList}
                                isOtherEnable={isOtherEnable}
                                onChangeAttrs={setOpenAttrsList}
                                deleteBIMAttrs={deleteBIMAttrs}
                                key={Attrs.Name}
                            />
                    )
                }
                <div className="field grid">
                    <div className="col-6 md:col-6">
                        {
                            isOtherEnable ?
                                <Button label="隱藏未選中屬性" className="p-button-warning" style={{ width: "100%" }} onClick={enableOtherAttr} /> :
                                <Button label="顯示未選中屬性" className="p-button-info" style={{ width: "100%" }} onClick={enableOtherAttr} />
                        }
                    </div>
                    <div className="col-6 md:col-6">
                        <Button label="清除所有上色" className="p-button-danger" style={{ width: "100%" }} onClick={clearEntityColor} />
                    </div>
                </div>
            </div>
        )
    }

    const OptionCard = () => {
        return (
            <Card style={{ marginTop: "1rem" }}>
                <div className="field grid">
                    <label htmlFor="coverDropdown" class="col-12 mb-4 md:col-4 md:mb-0">影像披覆：</label>
                    <div className="col-12 md:col-8">
                        <Dropdown className="inputfield w-full" inputId="coverDropdown" value={overlay} options={props.selected2Dlayer} onChange={(e) => setOverlayCover(e)} optionLabel="TITLE" showClear placeholder="Select a Overlay." />
                    </div>
                </div>
                <Divider />
                {BIMModelOption()}
            </Card>
        )
    }
    const layerGoto = () => {
        layer.layerObject.goto();
    }

    return (
        <div>
            <div className="layer-item">
                <div className="layer-detail">
                    <div className="layer-name">{layer.TITLE}</div>
                </div>
                <div className="layer-action">
                    <Button icon="pi pi-cog" className="p-button-rounded p-button-info" onClick={() => { setOptionOpen(!optionOpen) }} />
                    <Button icon="pi pi-map-marker" className="p-button-rounded p-button-info" onClick={() => { layerGoto() }} />
                    <Button icon="pi pi-times" className="p-button-rounded p-button-danger" onClick={() => { props.layerRemove(props.index) }} />
                </div>
            </div>
            {
                optionOpen ? OptionCard() : null
            }
            <Divider />
        </div>
    )
}